import { render } from "./Collapsible.vue?vue&type=template&id=0d0a1e35&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"

import "./Collapsible.vue?vue&type=style&index=0&id=0d0a1e35&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0a1e35"]])

export default __exports__